@use 'src/global/variables.scss' as var;
@use 'src/global/mixins/icon.scss' as icon;
@use 'src/global/mixins/feedback.scss' as fb;

c-bubble-collapsible {
  display: block;
  width: calc(100% - 24px);
  height: 100%;
  border-radius: 20px;
  background: var.$primary-color;
  box-shadow: var.$message-screen-elements-box-shadow;
  hyphens: none;
  -webkit-hyphens: none;

  .bubble-container-with-feedback {
    @include fb.bubble-container-with-feedback;
  }

  dl {
    margin: 0;
    box-sizing: border-box;
    color: var.$text-color-light;

    dt {
      button {
        span {
          padding-right: 1rem;
          display: inline-block;
        }
        display: flex;
        align-items: center;
        font-weight: bold;
        cursor: pointer;
        background: none;
        border: none;
        color: white;
        font-size: 1em;
        width: 100%;
        height: 100%;
        text-align: left;
        padding: 1rem;
        border-radius: 8px;
        &:focus {
          outline: none;
          box-shadow: inset 0 0 0 3px var.$focus-color;
        }
        &.collapsed:after {
          transform: rotate(90deg);
        }
        &:after {
          margin-left: auto;
          color: var.$text-color-light !important;
          font-size: 1rem !important;
          transform: rotate(-90deg);
          @include icon.icon;
          content: '\f119';
        }
      }
    }
    dd {
      padding: 1rem 1.5rem;
      margin: 0;
      &.collapsed {
        display: none;
      }
    }

    a {
      color: var.$text-color-light;
      text-decoration: underline;
      font-weight: bold;
      &:hover {
        color: var.$text-color-light; // For IE11 and Edge, where the styles clash with BA CSS
      }
    }
  }
}
